// extracted by mini-css-extract-plugin
export default {"container":"orderHistoryPage_container__CMYlU","card":"orderHistoryPage_card__31ofn"};